import timezones from "timezones-list"

const getTimeZoneOptions = () => {
  return timezones.map(({ tzCode: value, name: label }) => ({ value, label }))
}

export default getTimeZoneOptions
